import { usePayStore } from "@/store/pay";
import { useUserStore } from "@/store/user";
import { useEventTracking } from "@/hooks/useEventTracking";
import type { OpenMembershipFullscreenOptions } from "./types";

/** 展示成功受理后记录来源和购买前快照；权益请求由全屏宿主统一负责。 */
export function beginFullscreenPresentation(options: OpenMembershipFullscreenOptions): void {
  const pay = usePayStore();
  const user = useUserStore();
  pay.productModalState.open = false;
  pay.modalActiveType = options.initialTab === "group" ? "groupMember" : options.initialTab === "power" ? "power" : "member";
  user.setIsExpireUserBeforePay(user.isExpireUser);
  useEventTracking({ event: "ball", eventValue: {
    ball_type: "vip_packages_modal", from_view: pay.ballParams.view, from_button: pay.ballParams.button,
    active_tab: pay.modalActiveType, power_balance: user.powerNumber
  } });
}

/** 用户主动关闭才结束优惠券引导；路由/账号变化不视为用户拒绝购买。 */
export function dismissFullscreenPresentation(): void {
  const pay = usePayStore();
  useUserStore().markCouponFlowCompleted();
  useEventTracking({ event: "click", eventValue: {
    ball_type: "vip_packages_modal", from_view: pay.ballParams.view, from_button: pay.ballParams.button, button: "close"
  } });
}
